export const device = {
    phone: "(max-width: 600px)",
};
